import { useEffect, useRef } from 'react';
import { useOrchestratorState } from '@wix/gg-components/orchestrator';
import { getScreenNameFromStepId } from './biConstants';
import { biLogger } from './biLogger';

export function useStepPageViewTracker() {
  const { currentStep } = useOrchestratorState();
  const previousStepIdRef = useRef<string | null>(null);

  useEffect(() => {
    const currentStepId = currentStep?.id || null;

    if (currentStepId && currentStepId !== previousStepIdRef.current) {
      const screenName = getScreenNameFromStepId(currentStepId);

      if (screenName) {
        biLogger.pageView(screenName);
      }

      previousStepIdRef.current = currentStepId;
    }
  }, [currentStep?.id]);
}
